// activePropertySlides
export default function (state, getters, rootState, rootGetters) {
  const routeName = rootState.route.name

  console.log('activePropertySlides')

  if (['packages', 'package-modal'].includes(routeName)) {
    const _packages = getters['property/livingOptionsPackages'].filter(_package => {
      return !_package.filter
    })
    
    return _packages
      .map(_package => {
        return {
          backgroundImage: [..._package.dwelling.facadeImages, ..._package.dwelling.galleryImages, ..._package.property.viewImages, ..._package.property.galleryImages, ..._package.dwelling.floorplanImages][0],
          baths: _package.dwelling ? _package.dwelling.baths : '',
          beds: _package.dwelling ? _package.dwelling.beds : '',
          builder: _package.dwelling ? _package.dwelling.builderLabel : '',
          colourScheme: _package.dwelling ? _package.dwelling.colourScheme : '',
          houseDesign: _package.dwelling ? _package.dwelling.houseDesign : '',
          cars: _package.dwelling ? _package.dwelling.cars : '',
          _id: _package.id,
          images: [..._package.dwelling.facadeImages, ..._package.dwelling.galleryImages, ..._package.property.viewImages, ..._package.property.galleryImages, ..._package.dwelling.floorplanImages], 
          lotNumber: _package.property.label,
          lotSize: _package.property.size,
          dwellingSize: _package.dwelling.size,
          name: _package.label,
          price: _package.price,
          virtualTourUrl: _package.dwelling.virtualTourUrl,
          type: 'package'
        }
    })
  }

  if (['turnkeys', 'turnkey-modal'].includes(routeName)) {
    const turnkeyTypes = rootGetters['styleTemplate']['turnkey-page'].types

    const turnkeys = getters['property/turnkeys'].filter(turnkey => {
      return !turnkey.filter && turnkeyTypes.includes(turnkey.type)
    })

    return turnkeys
  }

  if (['dwellings', 'dwelling-modal'].includes(routeName)) {
    const dwellingTypes = rootGetters['styleTemplate']['dwelling-page'].types
    const dwellings = getters['property/livingOptionsDwellings'].filter(dwelling => {
      return !dwelling.filter && dwellingTypes.includes(dwelling.type)
    })
    
    return dwellings
      .map(dwelling => {
        return {
          backgroundImage: [...dwelling.facadeImages, ...dwelling.galleryImages, ...dwelling.floorplanImages][0],
          baths: dwelling ? dwelling.baths : '',
          beds: dwelling ? dwelling.beds : '',
          builder: dwelling ? dwelling.builderLabel : '',
          colourScheme: dwelling ? dwelling.colourScheme : '',
          houseDesign: dwelling ? dwelling.houseDesign : '',
          cars: dwelling ? dwelling.cars : '',
          _id: dwelling._id,
          images: [...dwelling.facadeImages, ...dwelling.galleryImages, ...dwelling.floorplanImages], 
          lotNumber: null,
          dwellingSize: dwelling.size,
          name: dwelling.label,
          price: dwelling.price,
          virtualTourUrl: dwelling.virtualTourUrl,
          minimumFrontage: dwelling.fitsOnProperty,
          type: 'dwelling'
        }
    })
  }

  if (['favourites', 'favourite-modal'].includes(routeName)) {
    const favourites = getters['favourites/favourites']

    return favourites
      .map(favourite => {
        let type = ''
        if (favourite.propertyId && favourite.dwellingId) {
          type = 'package'
        } else if (favourite.dwellingId) {
          type = 'turnkey'
        } else if (favourite.type === 'house') {
          type = 'house'
        } else {
          type = 'land'
        }

        let backgroundImage = []
        let images = []
        if (type === 'package') {
          backgroundImage = [...favourite.dwelling.galleryImages, ...favourite.property.viewImages, ...favourite.property.galleryImages, ...favourite.dwelling.floorplanImages][0]
          images = [...favourite.dwelling.galleryImages, ...favourite.property.viewImages, ...favourite.property.galleryImages, ...favourite.dwelling.floorplanImages]
        }
        if (type === 'house') {
          backgroundImage = [...favourite.galleryImages, ...favourite.floorplanImages][0]
          images = [...favourite.galleryImages, ...favourite.floorplanImages]
        }
        if (type === 'turnkey') {
          backgroundImage = [...favourite.dwelling.galleryImages, ...favourite.dwelling.facadeImages][0]
          images = [...favourite.dwelling.galleryImages, ...favourite.dwelling.facadeImages, ...favourite.dwelling.floorplanImages]
        }
        if (type === 'land') {
          backgroundImage = [...favourite.viewImages, ...favourite.galleryImages][0]
          images = [...favourite.viewImages, ...favourite.galleryImages]
        }
        

        return {
          backgroundImage: backgroundImage,
          baths: favourite.dwelling ? favourite.dwelling.baths : type === 'house' ? favourite.baths : '',
          beds: favourite.dwelling ? favourite.dwelling.beds : type === 'house' ? favourite.beds : '',
          builder: favourite.dwelling ? favourite.dwelling.builderLabel : type === 'house' ? favourite.builderLabel : '',
          colourScheme: favourite.dwelling ? favourite.dwelling.colourScheme : type === 'house' ? favourite.colourScheme : '',
          houseDesign: favourite.dwelling ? favourite.dwelling.houseDesign : type === 'house' ? favourite.houseDesign : '',
          cars: favourite.dwelling ? favourite.dwelling.cars : type === 'house' ? favourite.cars : '',
          _id: favourite._id,
          images: images,
          lotNumber: type === 'package' ? favourite.property.label : favourite.label,
          lotSize: type === 'package' ? favourite.property.size : favourite.size,
          name: type === 'package' ? favourite.label : '',
          price: favourite.price,
          type: type
        }
    })
  }
  
  return []
}